import React, { memo, useEffect, useRef, useState } from "react"
import { FeedComponentInfo } from "../../Services"
import { frames } from "../../Styles"
import { TooltipString } from "../BaseComponents";

const LabelsComponent = memo(({ component, width }: { component: FeedComponentInfo, width:Number }) => {
  const textRefs = useRef<Record<number, HTMLParagraphElement | null>>({});
  const [overflowMap, setOverflowMap] = useState<Record<number, boolean>>({});
  
  useEffect(() => {
    const newMap: Record<number, boolean> = {};
  
    Object.entries(textRefs.current).forEach(([id, el]) => {
      if (el) {
        newMap[parseInt(id)] = el.scrollWidth > el.clientWidth;
      }
    });
  
    setOverflowMap(newMap);
  }, [component]);

  if (component === undefined) return null;

  return (
    <div style={{width: `${width}px`}}>
    <TooltipString
      key={component.id}
      tooltipString={overflowMap[component.id] ? component?.name : undefined}
      contentString={
        <frames.GridLabel $component={component?.id} $width={"150px"}>
          <p
            ref={(el) => { textRefs.current[component.id] = el }}
            style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}
          >
            {component?.name}
          </p>
        </frames.GridLabel>
      }
      />
    </div>
  )
})

export default LabelsComponent;